/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_Panel_Row3Inputs */

const en_mk_proof_panel_row3 = /** @type {(inputs: Mk_Proof_Panel_Row3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`src/forms/onboarding.tsx changed`)
};

const id_mk_proof_panel_row3 = /** @type {(inputs: Mk_Proof_Panel_Row3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`src/forms/onboarding.tsx berubah`)
};

/**
* | output |
* | --- |
* | "src/forms/onboarding.tsx changed" |
*
* @param {Mk_Proof_Panel_Row3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_panel_row3 = /** @type {((inputs?: Mk_Proof_Panel_Row3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_Panel_Row3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_panel_row3(inputs)
	return en_mk_proof_panel_row3(inputs)
});